import { useTranslation } from "react-i18next";
import MPageHeader from "../components/commons/MPageHeader";
import { MAppLogo } from "../components/commons/MIcon";

const DeletedQR = () => {
  const { t } = useTranslation();

  return <>
    <div className="w-100 h-100 d-flex flex-column">
      <div className="py-3 d-flex justify-content-center">
        <MAppLogo height={24} />
      </div>
      <div className="flex-fill d-flex flex-column justify-content-center gap-3 position-relative">
        <div className="text-center fw-bolder" style={{ fontSize: 18, zIndex: 1 }}>
          <div className="px-4 mb-4">
            {t("This data was deleted by requesting of user.")}
          </div>
        </div>
        <div className="px-2 position-relative">
          <img
            src="/imgs/wrong-access.png"
            alt="loading"
            style={{
              width: "90%",
              maxWidth: 300,
              pointerEvents: "none",
              filter: "drop-shadow(0px 0px 100px var(--bs-warning-200))",
              WebkitFilter: "drop-shadow(0px 0px 100px var(--bs-warning-200))",
            }}
            className="mx-auto d-block"
          />
        </div>
      </div>
    </div>
    {/* <div className="w-100 h-100 d-flex flex-column">
      <MPageHeader />
      <div
        className="flex-fill d-flex flex-column px-4 text-start"
        style={{
          backgroundImage: `url("/imgs/welcome.png")`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "auto, auto"
        }}
      >
        <div className="fs-3 fw-bolder mt-4">
          {t("Your data has been deleted.")}
        </div>
        <div className="mt-2 fs-7">
          {t("To meet the new Virtual Smile, please request a new QR code.")}
        </div>
        <div className="flex-fill"></div>
      </div>
    </div> */}
  </>
};

export default DeletedQR;
